<script lang="ts" setup>
import { Button } from '~ds/components/ui/button';
import { useI18n } from 'vue-i18n';

interface Props {
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  disabled: false,
});

const emit = defineEmits<{
  signOut: [];
}>();

const { t } = useI18n();
</script>

<template>
  <Button
    variant="link"
    size="sm"
    type="button"
    :disabled="disabled"
    data-testid="auth-mfa-sign-out"
    @click="emit('signOut')"
  >
    {{ t('kui.auth.mfaSignOut') }}
  </Button>
</template>
